/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import dayjs from 'dayjs';
import JsFileDownloader from 'js-file-downloader';

export const downloadFile = (
  filename: string,
  url: string,
  onSuccess?: () => void,
  onFailure?: () => void
) => {
  new JsFileDownloader({
    contentType: false,
    url,
    filename
  })
    .then(() => {
      onSuccess?.();
    })
    .catch(() => {
      onFailure?.();
    });
};

/**
 * Check if the string is a filename with some extension
 * The regex checks for a valid filename with extension at the end of the string
 * @param str
 * @returns
 */
export const isFilenameWithExtension = (str: string) => {
  const regex =
    /(?:^|\/)[^@]*?([a-zA-Z0-9_-]+\.[0-9a-zA-Z]+(\.[0-9a-zA-Z]+)*)$/;

  return regex.test(str);
};

/**
 * Enum for file extensions.
 */
export enum FileExtension {
  CSV = 'csv',
  PDF = 'pdf'
  // Add more file extensions as needed
}

/**
 * Generates a file name by appending the current date and the provided extension.
 *
 * @param title - The title of the file.
 * @param extension - The file extension.
 * @returns The formatted file name.
 */
export const generateFileName = (title: string, extension: FileExtension) =>
  `${title}-${dayjs().format('YYYY-MM-DD')}.${extension}`;
